import { schPoolTypes } from '@aloft/toolkit-shared';
import { SimpleSelect, toOpts } from '@aloft/toolkit-sui';

import { UseFormRegister } from 'react-hook-form';

import { ObjectiveCharacteristicsFormInput } from '../schObjectiveCharacteristics.ts';

export const PoolTypeSelect = ({
  register,
}: {
  register: UseFormRegister<ObjectiveCharacteristicsFormInput>;
}) => (
  <SimpleSelect size="sm" {...register('pool.type')} required label="Type">
    {toOpts(schPoolTypes.options).map((opt) => (
      <option key={opt.value} value={opt.value}>
        {opt.label}
      </option>
    ))}
  </SimpleSelect>
);
